export default __webpack_public_path__ + "static/media/Lock Icon.3192897f.png";